const token = localStorage.getItem("token")

const accessToken = `Bearer ${token}`
export default accessToken
